import request from '@/utils/request'


// 查询音频信息列表
export function listMusic(query) {
  return request({
    url: '/music/music/list',
    method: 'get',
    params: query
  })
}

// 查询音频信息分页
export function pageMusic(query) {
  return request({
    url: '/music/music/page',
    method: 'get',
    params: query
  })
}

// 查询音频信息详细
export function getMusic(data) {
  return request({
    url: '/music/music/detail',
    method: 'get',
    params: data
  })
}

// 新增音频信息
export function addMusic(data) {
  return request({
    url: '/music/music/add',
    method: 'post',
    data: data
  })
}

// 修改音频信息
export function updateMusic(data) {
  return request({
    url: '/music/music/edit',
    method: 'post',
    data: data
  })
}

// 删除音频信息
export function delMusic(data) {
  return request({
    url: '/music/music/delete',
    method: 'post',
    data: data
  })
}
